import type z from 'zod/v4'
import { relations, sql } from 'drizzle-orm'
import { index, pgTable, text, timestamp, unique, uuid } from 'drizzle-orm/pg-core'
import { createInsertSchema, createSelectSchema, createUpdateSchema } from 'drizzle-zod'

import { user } from '../../auth'
import { LearnProgress } from '../tracker'

// =============================================================================
// CONTINUE LESSON - FORMER lookup table for "Lanjut Belajar". NOT READ OR WRITTEN ANY MORE.
// The carousel is computed live by `continueLessonLive`
// (packages/trigger/src/metrics/live/continue-lesson.ts). The table remains until a
// later migration drops it; its rows are frozen — do not read them.
// =============================================================================

export const ContinueLesson = pgTable(
  'continue_lesson',
  {
    id: uuid().defaultRandom().primaryKey(),
    userId: text()
      .references(() => user.id, { onDelete: 'cascade' })
      .notNull(),
    learnProgressId: uuid()
      .references(() => LearnProgress.id, { onDelete: 'cascade' })
      .notNull(),
    createdAt: timestamp({ mode: 'date', withTimezone: true }).defaultNow().notNull(),
    updatedAt: timestamp({ mode: 'date', withTimezone: true })
      .defaultNow()
      .$onUpdateFn(() => sql`now()`), // defaultNow() is required: $onUpdateFn alone does not fire on first INSERT
  },
  (t) => [
    index('idx_continue_lesson_user').on(t.userId),
    index('idx_continue_lesson_user_updated').on(t.userId, t.updatedAt),
    unique('uq_continue_lesson_user_progress').on(t.userId, t.learnProgressId),
  ],
)

export const continueLessonRelations = relations(ContinueLesson, ({ one }) => ({
  user: one(user, {
    fields: [ContinueLesson.userId],
    references: [user.id],
  }),
  learnProgress: one(LearnProgress, {
    fields: [ContinueLesson.learnProgressId],
    references: [LearnProgress.id],
  }),
}))

export const InsertContinueLessonSchema = createInsertSchema(ContinueLesson).omit({
  id: true,
  createdAt: true,
  updatedAt: true,
})

export const UpdateContinueLessonSchema = createUpdateSchema(ContinueLesson).partial().omit({
  id: true,
  userId: true,
  learnProgressId: true,
  createdAt: true,
  updatedAt: true,
})

export const SelectContinueLessonSchema = createSelectSchema(ContinueLesson)

export type InsertContinueLesson = typeof ContinueLesson.$inferInsert
export type UpdateContinueLesson = z.infer<typeof UpdateContinueLessonSchema>
export type SelectContinueLesson = typeof ContinueLesson.$inferSelect
